import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';

import EditorialHeader from './EditorialHeader';
import EditorialFooter from './EditorialFooter';

// ----------------------------------------------------------------------
// EditorialPageShell — the wrapper every inner page uses so the design
// matches the homepage: fixed brand header, film-grain overlay, paper
// background, brand text color, and the deep-navy footer.
// ----------------------------------------------------------------------
export default function EditorialPageShell({ title, description, children }) {
  return (
    <>
      <Helmet>
        <title>{title ? `${title}  ·  KBT` : 'KBT  ·  A House of Study & Prayer'}</title>
        {description && <meta name="description" content={description} />}
      </Helmet>

      <div className="editorial-grain" aria-hidden />

      <Box
        sx={{
          background: 'var(--paper)',
          color: 'var(--text)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <EditorialHeader />
        <Box component="main" sx={{ flex: 1 }}>
          {children}
        </Box>
        <EditorialFooter />
      </Box>
    </>
  );
}
